<template>
<div>
    
    <form @submit.prevent="login">
        <h1>Ingreso de Pacientes</h1>

        <!-- <a href="#0" class="social_bt facebook">Continuar con Facebook</a> -->
        <!-- <a href="#0" class="social_bt google">Continuar con Google</a> -->
        <!-- <div class="divider"><span>O ingresar con tu email</span></div> -->
        <div class="form-group">
            <input type="email" class="form-control" placeholder="Ingrese su email" v-model="email" required>
        </div>
        <div class="form-group">
            <input type="password" class="form-control" placeholder="Ingrese su contraseña" v-model="pass" required>
        </div>
        <router-link to="/forgot-password" tag="a" class="link_bright">Olvidé mi contraseña</router-link>

        <div class="alert alert-danger" v-if="loginError">
            Usuario y/o contraseña incorrectos. 
        </div>

        <div class="form-group text-center add_top_20">
            <input class="btn_1 medium" type="submit" value="Ingresar" v-if=" !loginIn">
            <input class="btn_1 medium" type="button" disabled value="Ingresando ..." v-else>
        </div>
         <p class="text-center link_bright">
            ¿Todavía no tenés una cuenta? <br><router-link tag="a" to="/register"><strong>Registrate ahora!</strong></router-link>
        </p>
    </form>
        
    
</div>
</template>

<script>
import axios from 'axios';
import { onLogin } from '../vue-apollo';
import { mapMutations } from 'vuex'

export default {
    name: 'LoginBox',
    data() {
        return {
            email: '',
            pass: '',
            loginError:false,
            loginIn:false,
        }
    },
    beforeMount(){
        this.logout();
    },
    methods: {
		...mapMutations(['authSuccess','logout']),
        login() {
            this.loginError=false;
            if( !this.loginIn && this.email !='' && this.pass!='' ){
                this.loginIn = true;
                axios.post('/auth/user/login', { email: this.email, password: this.pass })
                .then(request => {
                    let access_token = request.data.access_token;
                    let logged_user = request.data.user;
                    onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => { 
                        this.authSuccess({token:access_token, loggedUser: logged_user});
                        this.loginIn = false;
                        this.$ga.event('users', 'user-logged', logged_user.email)
                        this.$emit('logged');
                    
                    });				
                })
                .catch(() => 
                {
                    this.loginError=true;
                    this.loginIn = false;
                })
            }
		},
    }
}
</script>

<style scoped>
form { 
    max-width: 350px;
    margin: auto;
}


h1 {
    font-size: 22px;    
    text-align: center;
    margin: 20px 0 30px 0;
    
}

.divider {
    text-align: center;
    height: 1px;
    margin: 30px 0;
    background-color: #e1e8ed;
}

.divider span {
    position: relative;
    top: -17px;
    font-size: 11px;
    background-color: #fff;
    display: inline-block;
    padding: 10px;
    font-style: italic;
}



#login-2 {
    width: 650px;
    margin: 60px auto;
    color: #fff;
}

#login-2 .box_form {
    padding: 30px 0 0 0;
}

@media (max-width: 767px) {
    #login-2 .box_form {
        /* For less than 767px */
        padding: 20px 20px 0 20px;
    }
}

#login-2 .forgot {
    display: inline-block;
    margin-top: 5px;
}

@media (max-width: 767px) {
    #login-2 {
        /* For less than 767px */
        width: 100%;
        margin: 0;
    }
}

#login-2 h1 {
    font-size: 28px;
    font-size: 1.75rem;
    text-align: center;
    margin: 0 0 30px 0;
    color: #fff;
}

.box_login {
    width: 50%;
    float: left;
    border-right: 1px solid #e1e8ed;
    padding: 15px 25px;
}

@media (max-width: 767px) {
    .box_login {
        /* For less than 767px */
        width: 100%;
        border-right: 0;
        padding: 0;
    }
}

.box_login.last {
    border-right: 0;
}

a.social_bt {
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    text-align: center;
    color: #fff;
    min-width: 200px;
    margin-bottom: 15px;
    display: block;
    padding: 12px;
    line-height: 1;
    position: relative;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

a.social_bt:hover {
    -webkit-filter: brightness(115%);
    filter: brightness(115%);
}

a.social_bt.facebook:before,
a.social_bt.google:before,
a.social_bt.linkedin:before {
    font-family: 'ElegantIcons';
    position: absolute;
    left: 12px;
    top: 10px;
    font-size: 1rem;
    color: #fff;
}

a.social_bt.facebook {
    background-color: #3B5998;
}

a.social_bt.facebook:before {
    content: "\e093";
}

a.social_bt.google {
    background-color: #DC4E41;
}

a.social_bt.google:before {
    content: "\e096";
    top: 12px;
}

a.social_bt.linkedin {
    background-color: #0077B5;
}

a.social_bt.linkedin:before {
    content: "\e09d";
}
</style>
